<div class="col-lg-6 col-xs-12">

    <div class="panel panel-default">
        <div class="panel-body">

    <div style="display: block">
      <canvas baseChart
              [data]="pieChartData"
              [labels]="pieChartLabels"
              [chartType]="pieChartType"
              (chartHover)="chartHovered($event)"
              (chartClick)="chartClicked($event)"></canvas>
    </div>

  </div>
</div>
</div>




// WEBPACK FOOTER //
// ./src/app/report/charts/pie-chart/pie-chart.component.html